import React, { useState, useEffect } from 'react';
import ApiService from './services/apiservice';
import ima from './imasm.svg';
import { Link, Redirect } from 'react-router-dom';

const Login = ({ history }) => {
  const [email, setEmail] = useState('');
  const password = email;
  const [error, setError] = useState(null);
  const apiService = new ApiService();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const setSessionExpiration = () => {
    const expirationTime = new Date();
    expirationTime.setHours(23, 59, 59, 999);
    if (expirationTime.getTime() < new Date().getTime()) {
      expirationTime.setDate(expirationTime.getDate() + 1);
    }

    return expirationTime.getTime();
  };

  const handleSessionExpiry = () => {
    const storedSession = JSON.parse(localStorage.getItem('session'));

    if (storedSession) {
      const { expirationTime, country, email: storedEmail } = storedSession;
      const currentTime = new Date().getTime();

      if (currentTime > expirationTime) {
        localStorage.removeItem('session');
      } else {
        if (storedEmail === 'adminnavi@gmail.com' || storedEmail === 'ricardoramirez@sanmartinbakery.com') {
          history.push('/navideño-admin');
        } else if (country === 0 || country === '0') {
          history.push('/calendario-navideño-sv');
        } else if (country === 1 || country === '1') {
          history.push('/calendario-navideño-gt');
        }
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await apiService.login(email, password);

      if (!response.user.id) {
        setError('ID de usuario no encontrado en la respuesta del servidor');
        return;
      }

      const idUsuario = response.user.id;
      const expirationTime = setSessionExpiration();
      const country = response.user.country;

      localStorage.setItem('session', JSON.stringify({ email, idUsuario, country, expirationTime }));

      if (email === 'adminnavi@gmail.com' || email === 'ricardoramirez@sanmartinbakery.com') {
        history.push('/navideño-admin');
      } else if (country === 0) {
        history.push('/calendario-navideño-sv');
      } else if (country === 1) {
        history.push('/calendario-navideño-gt');
      }
    } catch (error) {
      setError('Correo no registrado. Por favor, verifica tus credenciales.');
      console.error('Error durante el inicio de sesión:', error);
    }
  };

  useEffect(() => {
    handleSessionExpiry();
  }, []);

  // Redirigir a /home si ya hay una sesión almacenada
  const storedSession = JSON.parse(localStorage.getItem('session'));
  if (storedSession) {
    return <Redirect to="/home" />;
  }

  return (
    <div>
      <Redirect to="/home" />;
      <div data-aos="fade-down" className="space-y-10">
        <Link to="/home">
          <div className="flex flex-col justify-center items-center " data-aos="fade-right" data-aos-duration="1500">
            <img src={ima} alt="imasm" className="img" />
          </div>
        </Link>
        <div className="flex flex-col justify-center">
          <h2 className="text-center text-xl font-bold leading-9 tracking-tight text-white px-6"> Inicia sesión con tu correo </h2>

          <div className="flex flex-col justify-center items-center mt-8">
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div>
                <div className="mt-2">
                  <input type="email" autoComplete="email"
                    className="custom-input mt-4"
                    placeholder="ejemplo-correo@gmail.com"
                    value={email} onChange={handleEmailChange} required />
                </div>
              </div>
              <button type="submit" className="button"> Continuar </button>
              {error && <p style={{ color: 'white' }}>{error}</p>}
            </form>

            <div className="mt-8">
              <p className="text-center sm:text-left text-white">
                ¿No tienes una cuenta?{' '}
                <Link to="/registro" className="inline-flex justify-center rounded-lg text-sm font-semibold py-2 px-4 text-white ring-1 ring-white hover:ring-slate-900/20">
                  <span>Registrar <span aria-hidden="true">→</span></span>
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;